import { Link } from 'react-router-dom';
import { Button } from '../../components/ui';

const WA_LINK = 'https://wa.me/19999787030';

export default function NotFound() {
  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-4 py-12 bg-bg">
      <div className="flex flex-col items-center gap-6 text-center max-w-sm">

        {/* Ilustração SVG minimalista */}
        <svg
          width="120" height="120" viewBox="0 0 120 120" fill="none"
          aria-hidden="true" className="text-text-muted"
        >
          <circle cx="60" cy="60" r="56" stroke="currentColor" strokeWidth="2" strokeDasharray="8 4" opacity="0.3" />
          <text x="60" y="72" textAnchor="middle" fontSize="40" fontWeight="700" fill="currentColor" opacity="0.15" fontFamily="system-ui">
            404
          </text>
          <path d="M44 44 L76 76M76 44 L44 76" stroke="currentColor" strokeWidth="3" strokeLinecap="round" opacity="0.4" />
        </svg>

        <div className="flex flex-col gap-2">
          <h1 className="text-3xl font-bold text-text-primary">Página não encontrada</h1>
          <p className="text-text-muted text-base">
            O endereço que você acessou não existe ou foi removido.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 w-full">
          <Link to="/" className="flex-1">
            <Button variant="primary" size="md" className="w-full">
              Voltar para o início
            </Button>
          </Link>
          <a href={WA_LINK} target="_blank" rel="noopener noreferrer" className="flex-1">
            <Button variant="secondary" size="md" className="w-full">
              Falar no WhatsApp
            </Button>
          </a>
        </div>
      </div>
    </div>
  );
}
